import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-checked",
  "use": "checkbox-checked-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"checkbox-checked\">\n  <path d=\"M20.152 26.404L16 30.579 29.345 44 59 14.175 54.848 10 29.345 35.65l-9.193-9.246zM56 32c0 13.2-10.8 24-24 24S8 45.2 8 32 18.8 8 32 8c2.4 0 4.5.3 6.6.9l4.8-4.8C39.8 2.9 35.9 2 32 2 15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30h-6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol